import Meta from '../types/negocio/Meta';
import api from './api';
import BaseService from './BaseService';

class MetaService extends BaseService<Meta> {  

  constructor() {
    super('meta', api);
  }  
 
}

export const metaService = new MetaService();